(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/collections/draws.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/collections/draws.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen.collections.Draws = Backbone.Collection.extend({
    model: svs.matchen.models.Draw,

    getDraw: function(drawNumber) {
      return this.find(function(draw) {
        return draw.get('drawNumber') == drawNumber;
      });
    },

    getDrawsByDate: function() {
      return this.groupBy(function(model) {
        return dateFns.format(new Date(model.get('regCloseTime')), 'yyMMdd');
      });
    },

    getUniqueDrawDays: function() {
      return _.uniq(
        _.map(this.models, function(draw) {
          return svs.utils.date
            .getLocalizedWeekday(draw.get('regCloseTime'))
            .toLowerCase();
        })
      );
    },

    getDrawsFromDrawNumbers: function(drawNumbers) {
      var draws = new svs.matchen.collections.Draws();
      var draw;

      _.each(
        drawNumbers,
        function(drawNumber) {
          draw = this.getDraw(drawNumber);
          if (draw) {
            draws.add(draw);
          }
        },
        this
      );

      return draws;
    },

    getFirstDrawByDate: function() {
      var sortedDraws = this.sortBy(function(draw) {
        return dateFns.getTime(new Date(draw.get('regCloseTime')));
      });

      return sortedDraws && sortedDraws[0];
    }
  });
})(Backbone, _, svs);


 })(window);